import { ESIIncludeWithClientFetch } from "@/components/__shared__/ESIIncludeWithClientFetch/ESIIncludeWithClientFetch";

export const AddToBasketESI = ({
  productId,
  quoteId,
}: {
  productId: string;
  quoteId: string;
}) => {
  const src = `/esi/add-to-basket/${productId}/?clientId=electricals&enabled=true${
    quoteId ? `&tradeInQuoteId=${quoteId}` : ""
  }`;

  return (
    <ESIIncludeWithClientFetch src={src} id="add-trade-in-to-basket-esi" />
  );
};
